import React from "react";
import { useTeamLocale } from "./TeamLocaleContext";

const BRAND_OPTIONS = [
  { value: "all", labelKey: "brandFilter.all" },
  { value: "dr-hoffmann", labelKey: "brandFilter.drHoffmann" },
  { value: "tawan-spa", labelKey: "brandFilter.tawanSpa" },
];

const TeamBrandFilter = ({ value, onChange }) => {
  const { t } = useTeamLocale();

  return (
    <label className="team-brand-filter">
      {t("brandFilter.label")}
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        {BRAND_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {t(opt.labelKey)}
          </option>
        ))}
      </select>
    </label>
  );
};

export default TeamBrandFilter;
